"use client";

import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/utils/shared";

const typographyVariants = cva("", {
  variants: {
    variant: {
      "display 1": "text-4xl leading-[50px] font-bold",
      "display subtitle 1": "text-[28px] leading-10 font-light",

      "heading 1": "text-[28px] leading-10 font-semibold",
      "heading 2": "text-2xl leading-9 font-semibold",
      "heading 3": "text-xl leading-7 font-semibold",
      "heading 4": "text-lg leading-6 font-normal",

      "body 1": "text-base leading-6 font-normal",
      "body 2": "text-sm leading-5 font-normal",

      "label 1": "text-base leading-6 font-semibold text-primary-600",
      "label 2": "text-base leading-6 font-normal",
      "label 3": "text-sm leading-5 font-semibold",
      "label 4": "text-sm leading-5 font-semibold text-neutral-700",
      "label 5": "text-sm leading-5 font-normal",
      "label 6": "text-xs leading-4 font-medium",

      "caption 1": "text-sm leading-5 font-normal",
      "caption 2": "text-xs leading-4 font-medium",
    },
  },
});

export interface TypographyProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof typographyVariants> {}

const Typography = React.forwardRef<HTMLSpanElement, TypographyProps>(
  ({ className, variant, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(typographyVariants({ className, variant }), className)}
      {...props}
    />
  )
);
Typography.displayName = "Typography";

export { Typography };
